var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 54,
    viewBox: "0 0 49 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3104 5.74711V47.7011C29.3104 49.923 31.1115 51.7241 33.3334 51.7241H42.5288C44.7506 51.7241 46.5517 49.923 46.5517 47.7011V5.74711C46.5517 3.52527 44.7506 1.72412 42.5288 1.72412H33.3334C31.1115 1.72412 29.3104 3.52527 29.3104 5.74711Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.44828
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72412 5.74711V47.7011C1.72412 49.923 3.52527 51.7241 5.74711 51.7241H14.9425C17.1643 51.7241 18.9655 49.923 18.9655 47.7011V5.74711C18.9655 3.52527 17.1643 1.72412 14.9425 1.72412H5.74711C3.52527 1.72412 1.72412 3.52527 1.72412 5.74711Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.44828
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47123 50.1147C5.2494 50.1147 3.44824 48.3136 3.44824 46.0918V7.19934C3.44824 4.97751 5.24939 3.17635 7.47122 3.17635L13.2183 3.17634C15.4402 3.17633 17.2413 4.97749 17.2413 7.19933V46.0917C17.2413 48.3136 15.4402 50.1147 13.2184 50.1147H7.47123ZM35.0574 50.1147C32.8356 50.1147 31.0344 48.3136 31.0344 46.0918V7.19935C31.0344 4.97751 32.8356 3.17636 35.0574 3.17636H40.8046C43.0264 3.17636 44.8276 4.97751 44.8276 7.19935V46.0918C44.8276 48.3136 43.0264 50.1147 40.8046 50.1147H35.0574Z",
    fill: "black",
    stroke: "#EDEBE6",
    strokeWidth: 2.87356
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.13f0e6042ada8ccb592a578fac6942d2.svg";
export { ForwardRef as ReactComponent };